import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[InputPositiveInteger]',
})


// TODO do we need this? 28.08.26
export class InputPositiveIntegerDirective {

  private readonly WHITE_LISTED_SPECIAL_KEYS: ReadonlyArray<string> =
    ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'Home', 'End', 'Shift', 'Tab',
      'Insert', 'PageUp', 'PageDown', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];

  private readonly WHITE_LISTED_INPUTS_WHOLE_NUMBERS: ReadonlyArray<string> =
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];


  private readonly COMMA_CHAR: string = ".";
  private readonly WHITE_LISTED_INPUTS_DECIMAL_NUMBERS: ReadonlyArray<string> = this.WHITE_LISTED_INPUTS_WHOLE_NUMBERS.concat([this.COMMA_CHAR]);




  @Input() minValue: number | undefined;
  @Input() maxValue: number | undefined;
  @Input() decimals: number | undefined;

  public constructor(private el: ElementRef) {
  }

  // this is used to cancel out any DEAD key events (after the fact) like tilde  => ^ ~
  // is it seems impossible to cancel out in the traditional way (keydown)
  @HostListener('document:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) : void {
    if (!event.target) {
      return;
    }

    const htmlInputElement = event.target as HTMLInputElement;
    if (!htmlInputElement) {
      return;
    }

    if (htmlInputElement.id !== this.el.nativeElement.id) {
      return;
    }

    const oldValue: string = (event.target as HTMLInputElement).value;
    if (this.decimals)
    {
      for (let i = 0; i < oldValue.length; i++) {
        const character = oldValue.charAt(i);
        if (this.WHITE_LISTED_INPUTS_DECIMAL_NUMBERS.includes(character) === false) {
          this.el.nativeElement.value = oldValue.replaceAll(character, '');
          return ;
        }
      }
    }
    else {
      for (let i = 0; i < oldValue.length; i++) {
        const character = oldValue.charAt(i);
        if (this.WHITE_LISTED_INPUTS_WHOLE_NUMBERS.includes(character) === false) {
          this.el.nativeElement.value = oldValue.replaceAll(character, '');
          return ;
        }
      }
    }
  }


  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) : void {

    //console.log('-----------  onKeyPress start ------------');
    try {

      if (!event.target) {
        return;
      }

      const htmlInputElement = event.target as HTMLInputElement;
      if (!htmlInputElement) {
        return;
      }
      if (htmlInputElement.id !== this.el.nativeElement.id) {
        //console.log('target is not the input field');
        return;
      }

      if (!this.minValue || !this.maxValue) {
        //console.log('minvalue or maxvalue is not set');
        return;
      }

      if (this.decimals && this.decimals <= 0) {
        throw new Error('Decimals must be greater than 0, otherwise remove the attribute from the html input markup');
      }

      const hasSelection = this.hasSelection();

      /*console.log('minValue: ' + this.minValue);
      console.log('maxValue: ' + this.maxValue);
      console.log('decimals: ' + this.decimals);
      console.log('selectionStart: ' + selectionStart);
      console.log('selectionEnd: ' + selectionEnd);*/

      const oldValue: string = (event.target as HTMLInputElement).value;
      const newKey: string = event.key;

      if (this.WHITE_LISTED_SPECIAL_KEYS.includes(newKey)) {
        return;
      }

      //console.log('oldValue : ' + oldValue);
      //console.log('newKey   : ' + newKey);

      if (this.handleWhiteListedInput(newKey, oldValue, event) === false) {

        return;
      }

      if (hasSelection && this.handleTypingOnSelection(newKey, oldValue, event) === false) {
        return;
      }

      if (!hasSelection && this.handleTypingOnNoSelection(newKey, oldValue, event) === false) {
        return;
      }
    }
    finally{
      //console.log('-------------------------------------');
    }
  }

  private hasSelection() : boolean {
    const selectionStart = this.el.nativeElement.selectionStart;
    const selectionEnd = this.el.nativeElement.selectionEnd;
    const hasSelection: boolean = selectionStart === 0 && selectionEnd > 0;
    return hasSelection;
  }

  private ignoreEvent(oldValue: string, event: KeyboardEvent) : boolean {
    //console.log('ignoreEvent: ' + event.key);
    this.setSelectionAllText(oldValue);
    event.preventDefault();
    return false; // for convenience
  }


  private setSelectionAllText(oldValue: string) {
    this.el.nativeElement.selectionStart = 0;
    this.el.nativeElement.selectionEnd = oldValue.length;
  }

  private handleDecimalsNotExceeded(oldValue: string, event: KeyboardEvent) : boolean {

    const indexComma = oldValue.indexOf(this.COMMA_CHAR);
    if (indexComma === -1)
    {
      return true;
    }

    const currentDecimals = oldValue.length - indexComma - 1;
    if (currentDecimals >= this.decimals!) {
      return this.ignoreEvent(oldValue, event);
    }
    return true;
  }

  private handleCommaRepeated(oldValue: string, newKey: string, event: KeyboardEvent) : boolean {
    if (!this.decimals) {
      return true;
    }

    if (!oldValue.includes(this.COMMA_CHAR)) {
      return true;
    }

    if (newKey === this.COMMA_CHAR) {
      return this.ignoreEvent(oldValue, event);
    }

    return true;
  }

  private handleTypingOnNoSelection(newKey: string, oldValue: string, event: KeyboardEvent) : boolean {
    const newValue = oldValue + newKey;
    const currentValue = Number(newValue);

    if (this.handleCommaRepeated(oldValue, newKey, event) === false) {
      return false;
    }


    if (this.handleDecimalsNotExceeded(oldValue, event) === false) {
      return false;
    }

    // only allow to type an initial zero if the minvalue is less than 1
    if (this.decimals && this.decimals >= 1 && newKey === "0" && oldValue.length === 0) {
      return false;
    }

    if (currentValue < this.minValue! && newValue != `0${this.COMMA_CHAR}`) {
      //console.log(`Value '${currentValue}' is less than minvalue '${this.minValue }'`);
      return this.ignoreEvent(oldValue, event);
    }
    if (currentValue > this.maxValue!) {
      //console.log(`Value '${currentValue}' is greater than maxvalue '${this.maxValue }'`);
      return this.ignoreEvent(oldValue, event);
    }

    return true;
  }


  private handleTypingOnSelection (newKey: string, oldValue: string, event: KeyboardEvent) : boolean {
    const newKeyIsANumber = !Number.isNaN(Number(newKey));
    if (!newKeyIsANumber) {
      return this.ignoreEvent(oldValue, event);
    }

    const newKeyAsInt = Number(newKey);
    const minValue:number = this.minValue!;
    const isNewInputZero = newKeyAsInt === 0;

    if (isNewInputZero && this.decimals && (minValue > 0 && minValue < 1)) {
      return false;
    }
    if (isNewInputZero && minValue > 0) {
      return this.ignoreEvent(oldValue, event);
    }
    return true;
  }

  private handleWhiteListedInput (newKey: string, oldValue: string, event: KeyboardEvent) : boolean {
    if (this.decimals && !this.WHITE_LISTED_INPUTS_DECIMAL_NUMBERS.includes(newKey)) {
      return this.ignoreEvent(oldValue, event);
    }

    if (!this.decimals && !this.WHITE_LISTED_INPUTS_WHOLE_NUMBERS.includes(newKey)) {
      return this.ignoreEvent(oldValue, event);
    }
    return true;
  }

}
